import { render, staticRenderFns } from "./YMDHI.vue?vue&type=template&id=00c85f6f&scoped=true&"
import script from "./YMDHI.vue?vue&type=script&lang=js&"
export * from "./YMDHI.vue?vue&type=script&lang=js&"
import style0 from "./YMDHI.vue?vue&type=style&index=0&id=00c85f6f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c85f6f",
  null
  
)

export default component.exports